
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      '& > * + *': {
        marginLeft: theme.spacing(2),
      },
      margin: `${theme.spacing(8)}px auto`,
    }
  })
);

export const ComponentLoadingIndicator: React.FC<{ isLoading: boolean, text?: string }> = ({ isLoading, text, children }) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <>
        <div className={classes.root}>
          <CircularProgress color="primary" />
          <Typography component="p" variant="subtitle2">{text || "Loading..."}</Typography>
        </div>
      </>
    )
  } else {
    return (<>{children}</>)
  }
}